import React from "react";
import Footer from "../Footer/footer";
import Header from "../Header/header";
import FAQSection from "../ClassIntroFAQ/classIntroFAQ"; // Adjust the path if needed

const Classadmissionform = () => {
  return (
    <>
      <Header />
      <div className="flex justify-center">
        <iframe
          title="Form"
          src="https://docs.google.com/forms/d/e/1FAIpQLSdk2UJOyYNADk6DImuIZHi2iWcApyWGA6JfN-eiFMXcyfa8Iw/viewform?embedded=true"
          width="640"
          height="2587"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >
          Loading…
        </iframe>
      </div>
      <div className="container mx-auto py-10 px-4">
        <h1 className="text-center font-nastaleeqKasheeda text-4xl">
          کلاس سے متعلق اکثر پوچھے گئے سوالات
        </h1>

        <FAQSection />
      </div>

      <Footer />
    </>
  );
};

export default Classadmissionform;
